//import jsSHA from "jssha";
import Swal from "sweetalert2";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_APIURL;
axios.defaults.withCredentials = true;
if (process.env.NODE_ENV !== "production") {
    axios.defaults.headers.common["X-Auth-Context"] = "cau";
}

export function PascalCase(string){
    try{
        return string.charAt(0).toUpperCase() + string.slice(1);
    }catch(e){
        return string;
    }
}

class httpAxios{
    async read(route,config ={}){
        if (!route) {
            //throw new Error('A rota é obrigatória');
            console.error('A rota é obrigatória');
        }
        try{
            const retorno = await axios.get(route, config);
            if(retorno.data.data){
                retorno.data = retorno.data.data;
            }
            return retorno.data;
        }catch (e) {
            console.error(e);
            return false;
        }
    }
}
export const api = new httpAxios();


export function getLocalidade(id){
    return this.$localidades.data.find(elem => elem.id === id);
}

export function obterClassePorLetra(nome) {
    const classes = ['bg-success', 'bg-primary', 'bg-secondary', 'bg-orange', 'bg-warning', 'bg-danger', 'bg-dark'];
    if (!nome || nome.length === 0) return classes[0];
    const primeiraLetra = nome.substring(0, 1).toUpperCase();
    const posicaoLetra = primeiraLetra.charCodeAt(0) - 'A'.charCodeAt(0);
    if (posicaoLetra < 0 || posicaoLetra > 25) return classes[0];
    const indiceClasse = posicaoLetra % classes.length;
    return classes[indiceClasse];
}

export function removerTagsHtml(htmlString) {
    // Retorna uma string vazia se a entrada for nula ou inválida
    if(!htmlString || htmlString.trim().length <= 0){
        return '';
    }
    if (!htmlString || typeof htmlString !== 'string') {
        return '';
    }

    // Cria um elemento div temporário
    const tempDiv = document.createElement('div');

    // Define o conteúdo HTML do div
    tempDiv.innerHTML = htmlString;

    // Retorna apenas o texto contido no div, ignorando as tags
    // Usamos os dois (textContent e innerText) para máxima compatibilidade entre navegadores.
    return tempDiv.textContent || tempDiv.innerText || '';
}

export function sucesso({ icon = "success", title = "Tarefa realizada com sucesso!", text= false, showConfirmButton = false, timer = 1500 } = {}) {
    Swal.fire({
        icon,
        title,
        text,
        showConfirmButton,
        timer,
    });
}
export function erro({ icon = "error", title = "Erro ao realizar tarefa!", text= false, showConfirmButton = true, timer = false } = {}) {
    Swal.fire({
        icon,
        title,
        text,
        showConfirmButton,
        timer,
    });
}

export function aviso({ icon = "warning", title = "Aviso!", text= false, showConfirmButton = true, timer = false } = {}) {
    Swal.fire({
        icon,
        title,
        text,
        showConfirmButton,
        timer,
    });
}
export function confirmar({
      confirmado = () => {},
      negado = () => {},
      options = {
          title: "Você está certo disso?",
          text:'Você não poderá reverter esta ação!',
          icon:'warning',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Sim, tenho certeza!",
          customClass: {
              confirmButton: "btn btn-success w-xs me-2",
              cancelButton: "btn btn-danger w-xs",
              denyButton: "btn btn-info w-xs me-2",
          },
          buttonsStyling: false,
          denyButtonText: "Não tenho certeza",
          showCloseButton: true
      }
  } = {}) {
    Swal.fire({
        ...options,
    }).then(function (result) {
        if (result.isConfirmed) {
            confirmado();
        } else if (result.isDenied) {
            negado();
        }
    });
}
export function gerarCorSequencial(index, saturacao = 0.8, luminosidade = 0.45) {
    const proporcaoAurea = 0.61803398875;
    let matiz = (index * proporcaoAurea) % 1; // Gera um número de 0 a 1 para a matiz

    // Converte de HSL (0-1) para HSL (graus, %, %)
    const h = matiz * 360;
    const s = saturacao * 100;
    const l = luminosidade * 100;

    return `hsl(${h}, ${s}%, ${l}%)`;
}

export function getObjectByString(obj, path) {
    if (typeof path === 'string') {
        path = path.split('.');
    }
    if (!Array.isArray(path) || path.length === 0) {
        return obj;
    }
    return getObjectByString(obj[path[0]], path.slice(1));
}
export function convertDate(dataString) {
    let parts = dataString.split(' ');
    let dateParts = parts[0].split('-');
    let timeParts = parts[1].split(':');
    return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
}
export function extractHour(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
}

export function loading(status){
    const preloader = document.getElementById('preloader');
    if(status){
        preloader.style.opacity = '1';
        preloader.style.visibility = 'visible';
        //Swal.showLoading();
    }else{
        preloader.style.opacity = '0';
        preloader.style.visibility = 'hidden';
    }
}

/**
 * Versão em Promise do `confirmar`, para fluxos assíncronos.
 *
 * O `confirmar` clássico recebe callbacks e devolve `undefined`. Escrever
 * `await confirmar(...)` "funciona" sem erro nenhum e aborta a ação em silêncio,
 * porque `undefined` é falsy — um bug caro de achar. Esta variante resolve
 * `true`/`false` e mantém o mesmo visual dos botões.
 *
 *   if (!(await confirmarAsync({ title: "Cancelar?", variant: "danger" }))) return;
 */
export function confirmarAsync({
    title = "Você está certo disso?",
    text = "Você não poderá reverter esta ação!",
    icon = "warning",
    confirmButtonText = "Sim, tenho certeza!",
    cancelButtonText = "Cancelar",
    variant = "success",
} = {}) {
    return Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        customClass: {
            confirmButton: `btn btn-${variant} w-xs me-2`,
            cancelButton: "btn btn-light w-xs",
        },
        buttonsStyling: false,
        showCloseButton: true,
    }).then((resultado) => Boolean(resultado && resultado.isConfirmed));
}
